module.exports = __webpack_public_path__ + "static/media/sel_events.1cdb3981.svg";